import { MILLISECONDS_PER_SECOND, SECONDS_PER_MINUTE } from 'constants/date';

const MINUTES_IN_HEARTBEAT_INTERVAL = 15;

export const HEARTBEAT_INTERVAL_MS =
  MINUTES_IN_HEARTBEAT_INTERVAL * SECONDS_PER_MINUTE * MILLISECONDS_PER_SECOND;

export const DEVICE_PLUGIN_NAME = 'Device';

export const CAPACITOR_UPDATER_PLUGIN_NAME = 'CapacitorUpdater';

// Push platform reported for the iOS VoIP (PushKit) token so the backend routes it to APNs VoIP.
export const VOIP_PUSH_PLATFORM = 'ios-voip';

// Device-registry push-binding tags. The VoIP token registers under its own tag so the backend keeps
// it as a SEPARATE binding from the standard (alert) push token rather than clobbering it.
export const DEVICE_PUSH_TAG = {
  VOIP: 'voip',
};
